require('./creditModifyAssociatedAccountStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText,FormattedText } = require('core/i18n').i18n;
const { getCurrentSelectAccount } = require('utilities/currentAccountsHelper.js');
// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class CreditModifyAssociatedAccountStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleAccountChange(accountId) {
        const { setNewAccount } = this.props;
        setNewAccount(accountId);
    }

    render() {
        const {
            immAccounts,
            immCard,
            accountsIndexes,
            immCreditCardModifyAccountState,
        } = this.props;

        const cardNumber = immCard.get('number');
        const beneficiaryName = immCard.get('beneficiaryName');
        const cardAlias = immCard.get('alias').get('current');
        const emptyAccountDisplay = '--------------------';
        const newAccountId = immCreditCardModifyAccountState.getIn(['steps', 0, 'newAccountId']);
        const newAccountIsDirty = immCreditCardModifyAccountState.getIn(['steps', 0, 'newAccountIsDirty']);
        const newAccountRequiredAlertVisible = newAccountIsDirty && (newAccountId === '' || newAccountId === undefined);
        let accountError = formatText('cardCharge-accountError');
        const questionMark = formatText('commons-questionMark');
        const newAccount = !!newAccountId ? immAccounts.get(newAccountId) : null;
        const newAccountNumber = !!newAccountId ? newAccount.getIn(['ibanComplex', 'codbban']): emptyAccountDisplay;

        const associatedAccountNumber = immCard.get('associatedAccount').replace(/ /g,'');
        const immAccount = immAccounts.filter(account => account.getIn(['ibanComplex', 'codbban']) === associatedAccountNumber).first();
        let selectedAccount= "";
        let enabled = true;
        if (immAccount !== undefined) {
            selectedAccount = getCurrentSelectAccount(immAccount);
        } else {
            enabled = false;
            accountError = formatText('accountModifyStep1-invalidAccountMsg');
        }
        const message = (
            <div>
                <p>
                    <FormattedText value="accountModifyStep1-agreeMessage" injectedStrings={[beneficiaryName]}/>
                </p>
                <p>
                    <FormattedText value="accountModifyStep1-requsetToModifyAccountMessage1" injectedStrings={[cardAlias,cardNumber,associatedAccountNumber,newAccountNumber]}/>
                </p>
                <p className="no-print-out">
                    <FormattedText value="accountModifyStep1-satisficationMessage" injectedStrings={[beneficiaryName]}/>{questionMark}
                </p>
            </div>
        )

        return (
            <article className="account-modify-view-step1">
                <header className="wizard_header">
                    <h1 className="account-modify-view-step1__title">
                        <FormattedText value="accountModifyStep1-title" />
                    </h1>
                    <section className="account-modify-view-step1__sub-title no-print-out">
                        <FormattedText value="accountModifyStep1-subTitle" />
                    </section>
                    <section className="account-modify-view-step1__info no-print-out">
                        <div>{selectedAccount}</div>
                    </section>
                </header>
                <section className="wizard__content">
                    <form id="frm_PassStep1_Info" className="account-modify-view-step1__form no-print-out">
                        <fieldset className="account-modify-view-step1__field">
                            <DropdownAccounts
                                placeholder={formatText('accountModifyStep1-firstStepAccount')}
                                immAccounts={immAccounts}
                                accountsIndexes={accountsIndexes}
                                currentAccountId={newAccountId}
                                onAccountChange={this.handleAccountChange}
                                showAvailableBalance={true}
                                error={newAccountRequiredAlertVisible}
                                errorMsg={accountError}
                                enabled={enabled}
                            />
                        </fieldset>
                    </form>
                    <div className="account-modify-view-step1__row-info">
                        <h1 className="account-modify-view-step1__title no-print-out">
                            <FormattedText value="accountModifyStep1-blockInfoTitle" />
                        </h1>
                        <section className="account-modify-view-step1__sub-title no-print-out">
                            <FormattedText value="accountModifyStep1-blockInfoSubTitle" />
                        </section>
                        <BlockInfo>
                            {message}
                        </BlockInfo>
                    </div>
                </section>
            </article>
        );
    }
}

CreditModifyAssociatedAccountStep1.propTypes = {
    actions: PropTypes.object,
    accountsIndexes: PropTypes.array,
    immAccounts: PropTypes.object,
    immAccountsState: PropTypes.object,
    immCard: PropTypes.object,
    setNewAccount: PropTypes.func,
    immStep: PropTypes.object,
    immCreditCardModifyAccountState: PropTypes.object
};

module.exports = CreditModifyAssociatedAccountStep1;

